/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Configuration name for HRIS integration data types
 */
export enum HRISConfigName {
    JOBS_CONFIG = 'jobsConfig',
    EMPLOYEES_CONFIG = 'employeesConfig',
    RANGES_CONFIG = 'rangesConfig',
}
